<app-header></app-header>
  
<router-outlet></router-outlet>

<app-footer *ngIf="router.url !== '/login' && router.url !== '/register-user' && router.url !== '/forgot-password'"></app-footer>